<template>
	<teleport to="body">
		<!--Modal Reserva correcta-->
		<div class="modal  fade" id="modalCameraScanSuccess" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered modal-fullscreen">
				<div class="modal-content bg-white">
					<div class="modal-header">
						<h1 class="text-uppercase fw-semibold app-subtitle-text-table" id="exampleModalLabel"> {{ t('kiosk.reservationSuccess.title') }}{{ nameUser }}!</h1>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body text-center text-uppercase d-flex flex-column justify-content-center align-items-center">
						<div class="container">
							<div class="row row-margin-x">
								<div class="col-12">
									<div class="f-modal-alert">
										<div class="f-modal-icon f-modal-success animate">
											<span class="f-modal-line f-modal-tip animateSuccessTip"></span><span class="f-modal-line f-modal-long animateSuccessLong"></span>
											<div class="f-modal-placeholder"></div>
											<div class="f-modal-fix"></div>
										</div>
									</div>
								</div>
							</div>

							<div class="row row-margin-x">
								<div class="col-12 ">
									<p class="m-0 fw-semibold app-subtitle-text-table">
										{{ t('kiosk.reservationSuccess.confirm') }}
									</p>
									<p class="m-0 app-subtitle-text-table">
										{{ nameReservation }} | {{ paxReservation }} {{ t('kiosk.reservationSuccess.people') }} | {{ hourReservation }}.
									</p>
								</div>
							</div>
							<div class="row row-margin-x">
								<div class="col-12 ">
									<p class="fw-semibold m-0 app-subtitle-text-table">
										{{ t('kiosk.reservationSuccess.digitalLetterReady') }}
									</p>
								</div>
							</div>
							<div class="row row-margin-x">
								<div class="col-12 ">
									<p class="m-0 app-subtitle-text-table">
										{{ t('kiosk.reservationSuccess.ourPersonalMessaging') }}
									</p>
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<DismissButton />
					</div>
				</div>
			</div>
		</div>
	</teleport>
	<teleport to="body">
		<!--Modal Tiene usuario pero no reserva-->
		<div class="modal fade" id="modalCameraScanNotReservation" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered modal-fullscreen">
				<div class="modal-content bg-white">
					<div class="modal-header">
						<h1 class="text-uppercase fw-semibold app-subtitle-text-table" id="exampleModalLabel">{{ t('kiosk.reservationNot.title') }}{{ nameUser }}!</h1>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body text-center text-uppercase d-flex flex-column justify-content-center align-items-center">
						<div class="container">
							<div class="row row-margin-x">
								<div class="col-12">
									<div class="f-modal-alert">
										<div class="f-modal-icon f-modal-warning scaleWarning">
											<span class="f-modal-body pulseWarningIns"></span>
											<span class="f-modal-dot pulseWarningIns"></span>
										</div>
									</div>
								</div>
							</div>

							<div class="row row-margin-x">
								<div class="col-12">
									<p class="m-0 fw-semibold app-subtitle-text-table">
										{{ t('kiosk.reservationNot.notReservation') }}
									</p>
								</div>
							</div>

							<div class="row row-margin-x">
								<div class="col-12">
									<p class="m-0 app-subtitle-text-table">
										{{ t('kiosk.reservationNot.ourPersonalMessaging') }}
									</p>
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<DismissButton />
					</div>
				</div>
			</div>
		</div>
	</teleport>

	<teleport to="body">
		<!--Modal Error con el QR-->
		<div class="modal fade" id="modalCameraScanError" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered modal-fullscreen">
				<div class="modal-content bg-white">
					<div class="modal-header">
						<h1 class="text-uppercase fw-semibold app-subtitle-text-table" id="exampleModalLabel">{{ t('kiosk.reservationError.title') }}</h1>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body text-center text-uppercase d-flex flex-column justify-content-center align-items-center">
						<div class="container">
							<div class="row row-margin-x">
								<div class="col-12">
									<div class="f-modal-alert">
										<div class="f-modal-icon f-modal-error animate">
									<span class="f-modal-x-mark">
										<span class="f-modal-line f-modal-left animateXLeft"></span>
										<span class="f-modal-line f-modal-right animateXRight"></span>
									</span>
											<div class="f-modal-placeholder"></div>
											<div class="f-modal-fix"></div>
										</div>
									</div>
								</div>
							</div>

							<div class="row row-margin-x">
								<div class="col-12">
									<p class="m-0 fw-semibold app-subtitle-text-table">
										{{ t('kiosk.reservationError.notQr') }}
									</p>
								</div>
							</div>

							<div class="row row-margin-x">
								<div class="col-12">
									<p class="m-0 app-subtitle-text-table">
										{{ t('kiosk.reservationError.ourPersonalMessaging') }}
									</p>
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<DismissButton />
					</div>
				</div>
			</div>
		</div>
	</teleport>

	<teleport to="body">
		<!--Modal Error hoy no es el día de la reserva-->
		<div class="modal fade" id="modalCameraScanErrorReservation" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered modal-fullscreen">
				<div class="modal-content bg-white">
					<div class="modal-header">
						<h1 class="text-uppercase fw-semibold app-subtitle-text-table" id="exampleModalLabel">{{ t('kiosk.reservationNotTheDay.title') }}{{ nameUser }}!</h1>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body text-center text-uppercase d-flex flex-column align-items-center justify-content-center">
						<div class="container">
							<div class="row row-margin-x">
								<div class="col-12">
									<div class="f-modal-alert">
										<div class="f-modal-icon f-modal-warning scaleWarning">
											<span class="f-modal-body pulseWarningIns"></span>
											<span class="f-modal-dot pulseWarningIns"></span>
										</div>
									</div>
								</div>
							</div>

							<div class="row row-margin-x">
								<div class="col-12">
									<p class="m-0 fw-semibold" style="font-size: 2rem">
										{{ t('kiosk.reservationNotTheDay.dontReservationYourNameToday') }}
									</p>
								</div>
							</div>

							<div class="row row-margin-x">
								<div class="col-12">
									<p class="m-0 app-subtitle-text-table">


										{{ t('kiosk.reservationNotTheDay.oneNotedName') }}<b>{{ nameReservation }}</b>
										{{ t('kiosk.reservationNotTheDay.forTheDay') }}
										<b>{{ hourReservation }}</b>
										{{ t('kiosk.reservationNotTheDay.at') }}
										<b>{{ hourReservation }}</b>
										{{ t('kiosk.reservationNotTheDay.for') }}
										<b>{{ paxReservation }}</b>
										{{ t('kiosk.reservationNotTheDay.people') }}
									</p>
								</div>
							</div>

							<div class="row row-margin-x">
								<div class="col-12">
									<p class="m-0 app-subtitle-text-table">
										{{ t('kiosk.reservationNotTheDay.ourPersonalMessaging') }}
									</p>
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<DismissButton />
					</div>
				</div>
			</div>
		</div>
	</teleport>

</template>
<script>
import * as bootstrap from 'bootstrap'
import { mapGetters } from 'vuex'
import { hideAllModals } from '@/utils'
import DismissButton from '@/components/shared/DismissButton.vue'
import { useI18n } from 'vue-i18n'


export default {
	name: 'ModalNotificationWelcom',
	components: { DismissButton },
	emits: [],
	setup() {
		const { t } = useI18n()

		return {
			t
		}
	},
	computed: {
		...mapGetters('kiosk', ['modalScannerQr']),
		firstReservation() {
			return this.modalScannerQr.firstReservation || {}
		},
		user() {
			return this.modalScannerQr.user || {}
		},

		hourReservation() {
			return this.firstReservation.startDate
		},
		nameReservation() {
			return this.firstReservation.name
		},
		paxReservation() {
			return this.firstReservation.pax
		},
		roomReservation() {
			return this.firstReservation.roomName
		},

		nameUser() {
			return this.user.name
		}
	},
	data() {
		return {}
	},
	mounted() {
	},
	beforeUnmount() {

	},
	watch: {
		modalScannerQr(newValue, oldValue) {
			if (this.$route.path === '/kiosk') return;

			console.log('Cambiando el valor de la valiable computada', newValue, oldValue)
			if (newValue.showModal === true) {
				this.showModal()
				hideAllModals()
			}
			if (newValue === false) {
				// this.showModal('scannerIncorrectly');
			}
		}
	},
	methods: {
		// showToast() {
		// 	const toastElement = document.getElementById(this.toast.idToast);
		// 	const toastInstance = bootstrap.Toast.getOrCreateInstance(toastElement);
		// 	toastInstance.show();
		// },
		showModal() {
			const modalElement = document.getElementById(this.modalScannerQr.idModal)
			if (modalElement) {
				let modalInstance = bootstrap.Modal.getInstance(modalElement)
				if (!modalInstance) {
					modalInstance = new bootstrap.Modal(modalElement, {
						backdrop: 'static',
						keyboard: false
					})
				}
				modalInstance.show()

				setTimeout(() => {
					modalInstance.hide()
				}, 20000)

			} else {
				console.error('Modal element not found:', this.modalScannerQr.idModal)
			}
		}
	}
}
</script>
